import { useState } from 'react';
import { INSTALL } from '@kilroy/shared';
import { Sheet } from './Sheet';

/* Soft gate, never a hard one.
 *
 * The spec is explicit: capture is not blocked behind installation. Someone
 * standing on an outcrop with an uninstalled browser tab still gets to record
 * what they're looking at. But the banner stays up, in ochre, until it's done —
 * because on iOS an uninstalled origin is subject to seven-day script-storage
 * eviction, and that is a real way to lose a field day.
 *
 * iOS has no beforeinstallprompt, so there is no button that can do this for
 * them. The walkthrough is the product.
 */

export function InstallBanner() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" className="installbar" onClick={() => setOpen(true)}>
        <span className="installbar__dot" aria-hidden="true" />
        <span className="grow">{INSTALL.notInstalled}</span>
        <span className="mono installbar__cta">How</span>
      </button>

      {open && (
        <Sheet title="Add to home screen" onClose={() => setOpen(false)}>
          <p style={{ marginBottom: 'var(--s-5)', lineHeight: 1.5 }}>{INSTALL.why}</p>

          <ol className="steps">
            <li>
              <span className="steps__n mono">1</span>
              <span>
                Tap the <strong>Share</strong> button in Safari’s toolbar — the square with
                an arrow coming out of it.
              </span>
            </li>
            <li>
              <span className="steps__n mono">2</span>
              <span>
                Scroll down and choose <strong>Add to Home Screen</strong>.
              </span>
            </li>
            <li>
              <span className="steps__n mono">3</span>
              <span>
                Tap <strong>Add</strong>. Open Kilroy from the home screen icon from now on.
              </span>
            </li>
          </ol>

          <p className="field__hint" style={{ marginTop: 'var(--s-5)' }}>
            Anything already captured stays where it is. Installing only changes how the
            phone protects it.
          </p>
        </Sheet>
      )}
    </>
  );
}
